import styled, { css } from "styled-components";
import { cssBody400 } from "../../typography/styles";
export const Placeholder = styled.span `
  ${cssBody400};
  color: ${(p) => p.theme.systemColors.grey300};

  ${(p) => p.$error &&
    css `
      color: ${(p) => p.theme.systemColors.red400};
    `}
`;
